import { Pipe, PipeTransform } from '@angular/core';
import { LsHelperService } from '../services/ls-helper.service';
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";

@Pipe({
  name: 'multiLangOriginal'
})
export class MultiLangOriginalPipe implements PipeTransform {

  constructor(private ls: LsHelperService, private sanitizer: DomSanitizer) { }

  transform(value: string, useInnerHtml: boolean = false): string | SafeHtml {
    // console.log("Valor recibido:", value);
    if (!value) {
      return '';
    }

    const lang = this.ls.get('SELECTED_LANGUAGE');
    const language = lang ? lang : 'es';

    if (!this.isValidJson(value)) {
      return useInnerHtml ? this.sanitizer.bypassSecurityTrustHtml(value) : value;
    }

    try {
      let translate = JSON.parse(value)[language];
      // console.log("Valor traducido:", translate);
      return useInnerHtml ? this.sanitizer.bypassSecurityTrustHtml(translate) : translate;
    } catch (e) {
      console.error("Error en  MultiLang Pipe JSON:", e);
      return useInnerHtml ? this.sanitizer.bypassSecurityTrustHtml(value) : value;
    }
  }

  private isValidJson(value: string): boolean {
    try {
      JSON.parse(value);
      return true;
    } catch (e) {
      return false;
    }
  }

}
